import { applyUserTranslationsAllTypes } from "@/lib/utils";
import type { GroupLayer } from "@/types/models/capas";
import { gruposCapasRepository } from "../repositories/grupos.repository";

export const gruposCapasService = {
  async fetchByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<GroupLayer[]> {
    const data = await gruposCapasRepository.fetchByTenant(params.tenantId);

    return applyUserTranslationsAllTypes(data ?? [], params.userLang, ["nombre"]);
  },
  create: gruposCapasRepository.create,
  update: gruposCapasRepository.update,
  delete: gruposCapasRepository.delete,
};